import OrderPlan from './index';

export default { path: '/home/OrderPlan', component: OrderPlan };
